import React from 'react';
import { SvgIcon } from '@material-ui/core';
import PasswordSvg from './Password.svg';

const PasswordIcon = () => (
  <SvgIcon component={PasswordSvg} />
);

export default PasswordIcon;
